import BaseService from "./base.service";
class AdvantageType extends BaseService {
  constructor() {
    super("advantage-type");
  }
}

export default new AdvantageType();
